<template>
  <div class="plat-form-wrap">
    <div class="slides-wrap">
      <a-carousel arrows>
        <div
          class="dot-item"
          :style="{ backgroundImage: `url(${bgImg})` }"
        ></div>
      </a-carousel>
      <div class="imgText">
        <!-- <div class="textClass">搭建高质量专利对接渠道</div>
        <div class="textClass">共享创新成果，提升转化效率</div> -->
        <div class="btn" @click="toRouter('dealInfos')" v-if="flag">
          查看全部
        </div>
      </div>
    </div>
    <div class="body-wrap home-mini-width">
      <TitleCard
        title="高校院所"
        :loading="collegesList.loading"
        :isEmpty="collegesList.isEmpty"
        :type="'firstCard'"
        @moreClick="toRouter('dealInfos', 'collegesList')"
      >
        <template>
          <Block :list="collegesList"></Block>
        </template>
      </TitleCard>
      <TitleCard
        title="国企单位"
        :loading="countryList.loading"
        :isEmpty="countryList.isEmpty"
        :type="'firstCard'"
        @moreClick="toRouter('dealInfos', 'countryList')"
      >
        <template>
          <Block :list="countryList"></Block>
        </template>
      </TitleCard>
      <TitleCard
        title="科研单位"
        :loading="scientificList.loading"
        :isEmpty="scientificList.isEmpty"
        :type="'firstCard'"
        @moreClick="toRouter('dealInfos', 'scientificList')"
      >
        <template>
          <Block :list="scientificList"></Block>
        </template>
      </TitleCard>
    </div>
  </div>
</template>

<script>
import Block from './component/block'
import { getTradingInfo } from '@/api/tradingInfos.js'
export default {
  data() {
    return {
      bgImg: require('@/assets/images/zQImg/成果展示banner.png'),
      flag: true,
      collegesList: {
        // 高校院所
        loading: false,
        isEmpty: false,
        tableList: [],
        imgSrc: require('@/assets/images/zQImg/成果展示高校院所.png'),
        params: { pageSize: 6, pageNum: 1, orgType: '0' }
      },
      scientificList: {
        // 科研
        loading: false,
        isEmpty: false,
        tableList: [],
        imgSrc: require('@/assets/images/ky.png'),
        params: { pageSize: 6, pageNum: 1, orgType: '1' }
      },
      countryList: {
        // 国企
        loading: false,
        isEmpty: false,
        tableList: [],
        imgSrc: require('@/assets/images/国企单位.png'),
        params: { pageSize: 6, pageNum: 1, orgType: '2' }
      }
    }
  },
  components: {
    Block
  },
  async created() {
    this.initResultInfo()
  },
  computed: {},
  mounted() {
    let key = process.env.VUE_APP_KEY
    switch (key) {
      case 'foShan': // 佛山
        this.bgImg = require('@/assets/images/foShanImg/成果展示banner.png')
        this.collegesList.imgSrc = require('@/assets/images/foShanImg/高校院所.png')
        this.scientificList.imgSrc = require('@/assets/images/foShanImg/科研单位.png')
        break
      case 'Hy': // 河源
        this.bgImg = require('@/assets/images/HyImg/成果展示banner.png')
        this.collegesList.imgSrc = require('@/assets/images/HyImg/成果展示 高校院所.png')
        this.countryList.imgSrc = require('@/assets/images/HyImg/成果展示 国企单位.png')
        break
      case 'Mm': // 茂名
        this.bgImg = require('@/assets/images/MmImg/成果展示banner.png')
        this.collegesList.imgSrc = require('@/assets/images/MmImg/成果展示 高校院所.png')
        this.countryList.imgSrc = require('@/assets/images/MmImg/成果展示 国企单位.png')
        break
      case 'Yj': // 阳江
        this.bgImg = require('@/assets/images/YjImg/成果展示banner.png')
        this.collegesList.imgSrc = require('@/assets/images/YjImg/成果展示高校院所.png')
        this.countryList.imgSrc = require('@/assets/images/YjImg/成果展示国企单位.png')
        break
      case 'Mz': // 梅州
        this.bgImg = require('@/assets/images/MzImg/成果展示banner.png')
        this.collegesList.imgSrc = require('@/assets/images/MzImg/高校院所.png')
        this.countryList.imgSrc = require('@/assets/images/MzImg/国企单位.png')
        this.scientificList.imgSrc = require('@/assets/images/MzImg/科研单位.png')
        break
      case 'SzTech': // 深圳市新材料产业知识产权运营公共服务平台
        this.bgImg = require('@/assets/images/SzTech/成果展示banner.png')
        this.collegesList.imgSrc = require('@/assets/images/SzTech/成果展示高校院所.png')
        this.countryList.imgSrc = require('@/assets/images/SzTech/成果展示国企单位.png')
        break
    }
  },
  methods: {
    toRouter(router, val) {
      let obj = {}
      let params = {}
      if (val) {
        obj = {
          fatherTag: '发布主体',
          childTagItem: {},
          checked: true,
          instance: {
            isMore: false,
            hasMore: false,
            moreTitle: '展开',
            name: '发布主体',
            prop: 'orgType',
            icon: '/static/fbzt.png',
            tagList: [
              {
                name: '高校院所',
                value: '0',
                key: 'cn'
              },
              {
                name: '科研单位',
                value: '1',
                key: 'at'
              },
              {
                name: '国企单位',
                value: '2',
                key: '2'
              }
              // {
              //   name: '不限',
              //   value: '',
              //   key: '_infinity'
              // }
            ],
            spliceIdx: -1
          }
        }
        if (val === 'collegesList') {
          obj.childTagItem = {
            name: '高校院所',
            value: '0',
            key: 'cn'
          }
        } else if (val === 'countryList') {
          obj.childTagItem = {
            name: '国企单位',
            value: '2',
            key: '2'
          }
        } else {
          obj.childTagItem = { name: '科研单位', value: '1', key: 'at' }
        }
        params = JSON.stringify(obj)
      }
      console.log(params)
      this.$router.push({
        name: router,
        params: { selectVal: params }
      })
    },
    async initResultInfo() {
      try {
        this.collegesList.loading = true
        this.scientificList.loading = true
        this.countryList.loading = true
        const data1 = await getTradingInfo(this.collegesList.params, {
          orgType: '0'
        })
        // const data1 = await getTradingInfo(this.collegesList.params, {})
        this.collegesList.tableList = data1.data.rows
        this.collegesList.isEmpty = data1.rows === 0 ? true : false
        const data2 = await getTradingInfo(this.scientificList.params, {
          orgType: '1'
        })
        this.scientificList.tableList = data2.data.rows
        this.scientificList.isEmpty = data2.rows === 0 ? true : false
        const data3 = await getTradingInfo(this.countryList.params, {
          orgType: '2'
        })
        this.countryList.tableList = data3.data.rows
        this.countryList.isEmpty = data3.rows === 0 ? true : false
      } catch (error) {
        this.$apiStatusHandler(99, error)
      } finally {
        this.collegesList.loading = false
        this.countryList.loading = false
        this.scientificList.loading = false
      }
    }
  }
}
</script>
